export class EventHeader {
}